export const LETTER_WIDTH = 0.8;
export const NUMBER_WIDTH = 0.6;
export const DIVIDER_WIDTH = 0.2;
export enum INLINE_INPUT_DISPLAY_TYPES {
    VISIBLE = 'visible',
    INVISIBLE = 'invisible',
}
export { MAX_URL_LENGTH } from '../../utils/validators';
